module.exports = __webpack_public_path__ + "img/carousel-productos-3.d1c8ddb2.jpg";